<template>
    <div class="container environment_wrap">

        <p class="page_title">접속환경 분석</p>

        <div class="section_wrap ">
            <div class="leftarea">
                <section class="section sec1">
                    <div class="sec_titbox">
                        <div class="leftbox">
                            <p class="tit">접속 장치 통계</p>
                        </div>
                        <div class="rightbox"></div>
                    </div>
                    <div class="card_box">
                        <div class="card">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/device_icon1.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">데스크탑</p>
                                <p class="desc">351</p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/device_icon2.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">모바일</p>
                                <p class="desc">351</p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/device_icon3.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">태블릿</p>
                                <p class="desc">0</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="rightarea">
                <section class="section sec2">
                    <div class="sec_titbox">
                        <div class="leftbox">
                            <p class="tit">접속 운영 체제</p>
                        </div>
                        <div class="rightbox"></div>
                    </div>
                    <div class="card_box2">
                        <div class="card wid30">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/system_icon1.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">Windows</p>
                                <p class="desc">223</p>
                            </div>
                        </div>
                        <div class="card wid30">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/system_icon2.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">Macintosh</p>
                                <p class="desc">116</p>
                            </div>
                        </div>
                        <div class="card wid30">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/system_icon3.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">iOS</p>
                                <p class="desc">37</p>
                            </div>
                        </div>
                        <div class="card wid50">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/system_icon4.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">Android</p>
                                <p class="desc">30</p>
                            </div>
                        </div>
                        <div class="card wid50">
                            <div class="iconbox">
                                <img :src="`${$STATIC_URL}/admin/img/system_icon3.png`" alt="">
                            </div>
                            <div class="txtbox">
                                <p class="tit">Others</p>
                                <p class="desc">12</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

    </div>
</template>
<script setup>
</script>
<style scoped></style>